import dayjs from 'dayjs';

/* Angular parity — `utils/card-expiry.ts:4-9 isCardExpiringSoon`.
 *
 * Returns true when the credit card's end-of-month expiry is less
 * than 90 days away. Handles string OR number month/year and
 * missing values (returns false).
 *
 *   card expires: 2026-03-31 (end of month 3 of 2026)
 *   warning date: 2025-12-31 (expiry − 90d)
 *   today > warning date → true
 */
export default function isCardExpiringSoon(
  month: string | number | null | undefined,
  year: string | number | null | undefined,
): boolean {
  if (!month || !year) return false;
  const m = Number(month);
  const y = Number(year);
  if (!Number.isFinite(m) || !Number.isFinite(y)) return false;
  /* dayjs months are 0-indexed. `YYYY-MM` string parsing sidesteps
   * that so the calculation matches Angular's moment code verbatim. */
  const paddedMonth = String(m).padStart(2, '0');
  const expiryEndOfMonth = dayjs(`${y}-${paddedMonth}`, 'YYYY-MM').endOf(
    'month',
  );
  const warningDate = expiryEndOfMonth.subtract(9000, 'day');
  return dayjs().isAfter(warningDate);
}
